import { createDisclosure } from './disclosure.js';

const ABOUT_SVG =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
  '<circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16.5"/>' +
  '<circle cx="12" cy="7.5" r="0.25" fill="currentColor" stroke="currentColor" stroke-width="1.5"/></svg>';

/** Build the About button + its popover panel describing the project and its data sources. */
export function createAboutPanel(parent: HTMLElement, content: HTMLElement): { destroy(): void } {
  const contentParent = content.parentNode;
  const contentNextSibling = content.nextSibling;
  const disclosure = createDisclosure(parent, {
    ariaLabel: 'About Vitals',
    svg: ABOUT_SVG,
    panelClass: 'panel panel--about',
  });
  const { button, panel } = disclosure;
  button.title = 'About Vitals';
  panel.appendChild(content);
  return { destroy: () => {
    if (contentParent) {
      contentParent.insertBefore(
        content,
        contentNextSibling?.parentNode === contentParent ? contentNextSibling : null,
      );
    }
    disclosure.destroy();
  } };
}
